import { useEffect } from 'react';
import cn from 'classnames';
import { REGEX_URL_BEGIN } from "../regex";
import { jsx as _jsx } from "react/jsx-runtime";
var Link = function Link(_ref) {
  var offsetKey = _ref.offsetKey,
    decoratedText = _ref.decoratedText,
    onNewLinkUrlFound = _ref.onNewLinkUrlFound,
    isDark = _ref.isDark;
  var text = decoratedText.substring(0, 1).toLowerCase().concat(decoratedText.substring(1));
  var url = text.match(REGEX_URL_BEGIN) ? text : "http://".concat(text);
  if (text.length > 30) {
    text = url.replace(REGEX_URL_BEGIN, '');
    if (text.length > 30) {
      text = text.substring(0, 30).concat('...');
    }
  }
  useEffect(function () {
    if (onNewLinkUrlFound) {
      onNewLinkUrlFound(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);
  return /*#__PURE__*/_jsx("a", {
    "data-offset-key": offsetKey,
    className: cn('break-all truncate', isDark ? 'link-level4-dark' : 'link-level4'),
    href: url,
    target: "_blank",
    rel: "noopener noreferrer",
    children: text
  });
};
export default Link;